import { getData, postData, putData } from '../../../shared/api/core';

export const getAllUsers = () => getData(`/lp/users`);

export const getUser = (emea) => getData(`/lp/users/${emea}`);

export const addUser = (data) => postData(`/lp/users`, data);

export const updateUser = (emea, data) => putData(`/lp/users/${emea}`, data);

export const bootstrapMe = () => postData(`/lp/users/bootstrap/me`, {});

export const updatePreferences = (emea, preferences) =>
  putData(`/lp/users/${emea}/preferences`, preferences);
